<template>
    <artmisads-modal
    v-model:open="visible"
    title="Bulk Update"
    :width="1200"
    :destroyOnClose="false"
    :maskClosable="false"
    :footer="null"
   
  >
    <div>
  <a-spin :spinning="loading">
    <div class="example-table">
      <div class="notice">
        <p>Upload a CSV file with the following columns</p>
      <div class="down-example">
        <artmisads-select-button @click="exportDownloadProductTemplate">
          <svg class="icon icon-daochu1" aria-hidden="true">
            <use xlink:href="#icon-daochu1"></use>
          </svg>
          Download the Template
        </artmisads-select-button>
      </div>
      </div>
     
      <div class="content">
        <div class="content-left">
        
          <div class="file-name" v-if="fileName">
            <div>
              <svg class="icon icon-biaoge" aria-hidden="true">
                <use xlink:href="#icon-biaoge"></use>
              </svg>
              <span class="name">{{fileName}}</span>
              <svg class="icon close-cu" aria-hidden="true" @click="clearFile">
                <use xlink:href="#icon-close-cu"></use>
              </svg>
            </div>
          </div>
          <a-upload
            name="avatar"
            list-type="picture-card"
            :show-upload-list="false"
           
            :before-upload="beforeUpload"
            @change="handleChange"
            v-else
          >
            <p class="ant-upload-drag-icon">
              <inbox-outlined></inbox-outlined>
            </p>
            <svg class="icon shangchuan2" aria-hidden="true">
              <use xlink:href="#icon-jiahao-cu"></use>
            </svg>
            Choose a file...
          </a-upload>
        </div>
       
      </div>
      <!-- <div class="next-btn"> -->
        <!--  -->
        <!-- <artmisads-button type="primary" @click="toNext" v-if="successCount">
          Upload
        </artmisads-button> -->
        <!-- v-else -->
        <!-- <artmisads-button type="primary"  disabled>Next</artmisads-button> -->
      <!-- </div> -->
    </div>
  </a-spin>
  </div>
    </artmisads-modal>
</template>
<script setup>

  import { message } from 'ant-design-vue';
  import { ref, defineEmits ,defineExpose} from 'vue';
  import { financeApi } from "~/server/operator/finance"
  const emits = defineEmits(['submit']);
  const visible = ref(false);
  const fileName = ref('');
  const loading = ref(false);
  const props = defineProps([
    'setDataList', 'setShowExample', 'dataList'
  ]);
  const failureCount = ref(0);
  const successCount = ref(0);
  const clearFile = () => {
    fileName.value = '';
   successCount.value = 0;
   failureCount.value = 0;
  }

  

  const exportDownloadProductTemplate = () => {
    const finalParams = {
      qs: {},
      fileName: 'template.csv',
     platform:'operator'
    }
    financeApi.downloadProductSensitiveAsinFile(finalParams);
  }

  const handleChange = async ({file}) => {
    const { type, originFileObj, percent, name } = file;
    let form = new FormData();
		form.append('file', originFileObj);
    if (percent === 100) {
      if (type !== 'text/csv') {
        return message.error('Please upload a csv file.');
      } else {
        loading.value = true;
        let res = await financeApi.productSensitiveUpload(form);
        const { success, error, data } = res;
        
        if (success) {
          successCount.value = data.successCount ;
          failureCount.value = data.failureCount ;
          if (!successCount.value && !failureCount.value) {
            message.warning('No matching data found.');
            return
          } 
          if(successCount.value){
            message.success('Success');
            fileName.value = name;
            visible.value = false;
            emits('submit');
          }else{
            message.error('Upload Failed');
            visible.value = false;
          }
          
        }else{
          message.error(error);
          
        }
        loading.value = false;
      }
    }
  }

  
defineExpose({
  show: () => {
    visible.value = true;
    successCount.value = 0;
   failureCount.value = 0;
      fileName.value = '';
  }
})
</script>

<style lang="less" scoped>

    .notice {
      padding-right: 131px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > p {
        letter-spacing: 0.4px;
        line-height: 20px;
        color: var(--dark-2);
        padding-top: 8px;
        &:last-child {
          padding-top: 10px;
        }
      }
    }
    
    .content {
      padding: 12px 0 24px ;
      display: flex;
      :deep(.ant-table-wrapper) {
        .ant-table-cell {
          padding: 8px;
          line-height: 20px;
          word-break: break-word;
          border-color:  var(--border-4) !important;
        }
        .ant-table-thead {
          .ant-table-cell {
          border-bottom-color:  var(--border-1) !important;
          }
        }
        .ant-table-container {
          border-color:  var(--border-4) !important;
        }
        table {
          border-top: none !important;
          border-color:  var(--border-4) !important;
        }
      }
    }
    .content-right {
      margin-left: 8px;
      margin-top: 40px;
      .description,
      .required,
      .example {
        display: flex;
        .line {
          width: 2px;
          height: 100%;
        }
        .text {
          font-weight: 500;
          line-height: 20px;
          padding-left: 8px;
          padding-right: 8px;
          height: 20px;
          align-self: center;
          border-radius: 4px;
          margin-left: 16px;
        }
      }
      .description {
        height: 112px;
        .line {
          background-color: var(--primary-bg);
        }
        .text {
          color: var(--primary-text);
          background-color: var(--table-cell-bg-3);
          border: 1px solid var(--primary-border-3);
        }
      }
      .required {
        height: 34px;
        margin-top: 4px;
        .line {
          background-color: var(--yellow-5);
        }
        .text {
          color: var(--yellow-4);
          background-color: var(--table-cell-bg-2);
          border: 1px solid var(--yellow-5);
        }
      }
      .example {
        height: 144px;
        margin-top: 4px;
        .line {
          background-color: var(--green-4);
        }
        .text {
          color: var(--green-1);
          background-color: var(--table-cell-bg-1);
          border: 1px solid var(--green-2);
        }
      }
    }
    .table {
      width: 1020px;
    }
    .down-example {
      margin-top: 12px;
      button {
        display: flex;
        svg {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          align-self: center;
        }
      }
    }
    .content-left {
      flex: 1;
      .file-name {
        display: flex;
        width: 100%;
        height: 60px;
        cursor: pointer;
        background: var(--big-bg-1);
        border-radius: 8px;
        color: var(--dark-2);
        margin-top: 8px;
        &:hover {
          background: var( --bg-gray-2);
        }
        > div {
          display: flex;
          height: 28px;
          padding: 0 24px;
          border-radius: 8px;
          align-self: center;
          // &:hover {
          //   background-color: var(--bg-gray-4);
          // }
          .icon-biaoge {
            width: 24px;
            height: 24px;
            fill: var( --primary-text);
            align-self: center;
          }
          .name {
            color: var( --primary-text);
            font-weight: 500;
            font-size: 16px;
            letter-spacing: 0.4px;
            line-height: 22px;
            margin-left: 8px;
            margin-right: 24px;
            align-self: center;
          }
          .close-cu {
            cursor: pointer;
            width: 24px;
            height: 24px;
            padding: 4px;
            align-self: center;
            fill: var(--dark-3);
            &:hover {
              fill: var(--dark-1);
            }
          }
        }
        
      }
      :deep(.ant-upload-wrapper){
        margin-top: 16px;
        .ant-upload.ant-upload-select {
          width: 100%;
          height: 60px;
          color: var(--dark-2);
          background: var(--big-bg-1);
          border: 1px dashed var(--border-1);
          border-radius: 8px;
          font-size: var(--font-size-h-l);
          font-weight: 500;
          &:hover {
            background: var( --bg-gray-2);
            border: 1px dashed var(--bg-gray-7);
          }
          svg {
            width: 24px;
            height: 24px;
            fill: var(--dark-2);
            margin-right: 8px;
          }
        }
      }
    }
    .next-btn {
      border-top: 1px solid var(--border-4);
      padding: 10px 0 0 0;
      display: flex;
      justify-content: right;
      // > button {
      //   border: 2px solid var(--primary);
      //   box-shadow: var(--section-box-shadow-2);
      //   background-color: var(--color-white) !important;
      //   color: var(--primary);
      //   svg {
      //     fill: var(--primary);
      //     margin-left: 8px;
      //   }
      // }
    }

</style>